export const LOGIN_SUCCESSFUL = "LOGIN_SUCCESSFUL";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const LOGOUT_SUCCESSFUL = "LOGOUT_SUCCESSFUL";
export const LOGOUT_FAILED = "LOGOUT_FAILED";

export const loggedIn =  () => {
    return async (dispatch: Function, getState: Function) => {
        try {
            dispatch({
                type: LOGIN_SUCCESSFUL
            });
        } catch(error) {
            dispatch({
                type: LOGIN_FAILED,
                payload: {
                    message: error
                }
            })
        }
    }
}

export const loggedOut =  () => {
    return async (dispatch: Function, getState: Function) => {
        try {
            dispatch({
                type: LOGOUT_SUCCESSFUL
            });
        } catch(error) {
            dispatch({
                type: LOGOUT_FAILED,
                payload: {
                    message: error
                }
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/login.ts